import { useRef, useState } from 'react'
import { SuggestionsMessageContent } from '../ChatMessages/types'
import { ChatMode } from './types'

export const useChatMode = () => {
  const trackedCarouselMessageIds = useRef<Set<number>>(new Set())
  const trackedSuggestions = useRef(new Set<SuggestionsMessageContent>())
  const [isChatModalOpen, setIsChatModalOpen] = useState(false)
  const [chatMode, setChatMode] = useState(ChatMode.CHAT)
  const [selectedProductId, setSelectedProductId] = useState<string | null>(
    null,
  )
  const [shouldShowDisclaimer, setShouldShowDisclaimer] = useState(true)
  const [isOptionsMenuOpen, setIsOptionsMenuOpen] = useState(false)

  const disableDisclamer = () => {
    setShouldShowDisclaimer(false)
  }

  const openChatModal = () => {
    setIsChatModalOpen(true)
  }

  const resetToStartMode = () => {
    setChatMode(ChatMode.CHAT)
    setShouldShowDisclaimer(true)
    trackedCarouselMessageIds.current.clear()
    trackedSuggestions.current.clear()
  }

  const switchToLoadingConversation = () => {
    setChatMode(ChatMode.LOADING_CONVERSATION)
  }

  const switchToProductMode = () => {
    setChatMode(ChatMode.PRODUCT_DETAILS)
  }

  const switchToChatMode = () => {
    setChatMode(ChatMode.CHAT)
  }

  const switchToErrorScreenMode = () => {
    setChatMode(ChatMode.ERROR_SCREEN)
  }

  const hideChatModal = () => {
    setIsChatModalOpen(false)
  }

  const switchToSessionLoadingMode = () => {
    setChatMode(ChatMode.LOADING_CONVERSATION)
  }

  return {
    trackedCarouselMessageIds,
    trackedSuggestions,
    isChatModalOpen,
    openChatModal,
    hideChatModal,
    switchToLoadingConversation,
    switchToChatMode,
    switchToProductMode,
    selectedProductId,
    setSelectedProductId,
    switchToErrorScreenMode,
    switchToSessionLoadingMode,
    chatMode,
    shouldShowDisclaimer,
    disableDisclamer,
    resetToStartMode,
    isOptionsMenuOpen,
    setIsOptionsMenuOpen,
  }
}
